

import React from 'react'
import { Route, Routes } from 'react-router-dom'
import { useMediaQuery } from '@mui/system'
import BusinessesList from '../../Components/AdminUser/Businesses/BusinessesList'
import BusinessRouteAccess from './BusinessRouteAccess'
import BusinessAppointments from '../../Components/BusinessUser/BusinessAppointments/BusinessAppointments'
import BusinessSidebar from '../../Container/BusinessUser/BusinessSidebar'
import BusinessEmployeeList from '../../Components/BusinessUser/BusinessEmployee/BusinessEmployeeList'


const BusinessRoutes = () => {
  const isLargeScreen = useMediaQuery("(min-width:1441px)");

  return (
    <div>
          <div>
      <BusinessSidebar />
      <div style={{ marginLeft: isLargeScreen ? '250px' : '0', flexGrow: 1, padding: "10px" }}>

      <Routes>
          <Route path="/appointments" element={<BusinessRouteAccess element={<BusinessAppointments />} />}/>
          <Route path="/employees" element={<BusinessRouteAccess element={<BusinessEmployeeList />} />}/>
          {/* <Route path="/employees" element={<BusinessRouteAccess element={<EmployeesList/>} />}/> */}
      </Routes>
    </div>
    </div>
    </div>
  )
}

export default BusinessRoutes